export const EvaluationInfoEnum = {
EvaluationStepInfo: "EvaluationStepInfo",
EvaluationInfo: "EvaluationInfo",
ourLawInfo: "ourLawInfo",
otherRequirementInfo: "otherRequirementInfo",
updateConnectionInfo: "updateConnectionInfo",
OurLawCheckListInfo:"OurLawCheckListInfo",
OtherRequirementCheckListInfo:"OtherRequirementCheckListInfo"
};

export const EvaluationInfoType = Object.values(EvaluationInfoEnum);